import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UsuarioService } from './usuario.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';



@Injectable({ providedIn: 'root' })
export class HttprService {

    private apiUrl:string;
    constructor(private http: HttpClient, private usuario: UsuarioService) {
        this.apiUrl = environment.apiUrl
     }
    private Cabezera() {
        // this.usuario = JSON.parse(localStorage.getItem("usLog"))
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.usuario.actual?.token}`
        })
    }

    public POST<T>(url, solicitud: any) {
        return this.http.post<T>((this.apiUrl+ url), solicitud, {
            headers: this.Cabezera(),
        }).pipe(catchError(error => {
            console.log(error);
            return throwError(error);
        }));
    }
    public GET<T>(url, params: HttpParams) {
        return this.http.get<T>((this.apiUrl + url), {
            headers: this.Cabezera(),
            params: params
        }).pipe(catchError(error => {
            console.log(error);
            return throwError(error);
        }));
    }


}
